import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faPen } from "@fortawesome/free-solid-svg-icons"

export const Pen = (props) => {
  return <FontAwesomeIcon faIcon={faPen} {...props} />
}
